const messages = {
  threads: {
    orders: { title: "", content: "" },
    externalTraining: { title: "", content: "" },
    InvestmentSupport: { title: "", content: "" },
    onlineTraining: { title: "", content: "" },
    bTraining: { title: "", content: "" },
    hunter: { title: "", content: "" },
    profileComplete: { title: "", content: "" },
    activeUser: { title: "", content: "" },
    deleteItemFromOrder: { title: "", content: "" },
    deleteOrder: { title: "", content: "" },
    commitmentLetter: {
      title: "Thank You For Registering",
      content:
        "Dear<br/>Thank you for registering. We are pleased to inform you that your registration on BRIDGESTONE PLUS has been reviewed and approved.<br/>We hope BRIDGESTONE PLUS brings you success and valuable opportunities, and we look forward to continued collaboration.<br/>Best regards,<br/>The BRIDGESTONE PLUS Team",
    },
    uberall: { title: "", content: "" },
    welcome: {
      title: "Thank You For Registering",
      content:
        "Dear<br/>Thank you for registering. We are pleased to inform you that your registration on BRIDGESTONE PLUS has been reviewed and approved.<br/>We hope BRIDGESTONE PLUS brings you success and valuable opportunities, and we look forward to continued collaboration.<br/>Best regards,<br/>The BRIDGESTONE PLUS Team",
    },
    booster: { title: "", content: "" },
    orderStatus_RETURNED: { title: "", content: "" },
    orderStatus_REJECTED: { title: "", content: "" },
    kickbackPayback: { title: "", content: "" },
    survey_thankyou: { title: "", content: "" },
    survey: { title: "", content: "" },
    salesPromotions: { title: "", content: "" },
  },
};

export default {
  messages,
};
